import { Injectable } from '@angular/core';


export class AlertConfig {
  /** default alert type */
  public type: string = 'warning';

  /** is alerts are dismissible by default */
  public dismissible: boolean = false;

  /** default time before alert will dismiss */
  public dismissOnTimeout?: number = undefined;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
